var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("SubHeaderDash"),
      _vm._v(" "),
      _c("DashCards", { attrs: { dashItems: _vm.dashboardCards } }),
      _vm._v(" "),
      _c("EventDetailModal"),
      _vm._v(" "),
      _c("ManageEmailModal"),
      _vm._v(" "),
      _c("EmailHistoriesManagement")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33d349c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33d349c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/Dashboard.vue
// module id = 1865
// module chunks = 1